import type { FormType } from 'fundraising-core'
import { contentfulFormId } from '~/libs/formsDrupal'

/**
 * The `stats` a Contentful page posts beside its body, naming the form the server counts its
 * sign-up under (libs/server/legacyFormStats.ts). A debug-mode sign-up counts nowhere.
 */
export const contentfulStats = (
  slug: unknown,
  formLang: string,
  isDebug: boolean,
  formType?: FormType,
) =>
  isDebug
    ? undefined
    : {
        formId: contentfulFormId([slug].flat().join('/')),
        formLang,
        ...(formType ? { formType } : {}),
      }

/**
 * act's /foretagsgava renders Gåva's entries, but counts as Företagsgåva: its standard under the
 * Företagsgåva standard's slug, a campaign under `foretag-<slug>`, as Drupal's company slugs go
 * (CompanyImporter). A company form's stats type is `donation`, so the slug alone keeps it out of Gåva.
 */
export const companyStats = (
  slug: unknown,
  defaultSlug: string,
  formLang: string,
  isDebug: boolean,
) => {
  const name = [slug].flat().join('/')
  const own = !name || name === 'standard' || name === defaultSlug ? 'foretag' : `foretag-${name}`
  return contentfulStats(own, formLang, isDebug, 'donation')
}
